export enum WorkflowType {
    General = 1,
    ProjectWS,
    StudyPlanner,
}

export const getWorkflowTypeString = (workflowTypeID: number): string => {
    switch (workflowTypeID) {
        case WorkflowType.General:
            return "General";
        case WorkflowType.ProjectWS:
            return "Project WS";
        case WorkflowType.StudyPlanner:
            return "Study Planner";
        default:
            return "";
    }
};


export enum WorkflowRefColumn {
    Ref = 1,
    ExternalRef,
}

export enum TaskPriority {
    Low = 1,
    Medium,
    Normal,
    High,
    Critical
}

export const TaskPriorityColors: { [key: number]: string } = {
    [TaskPriority.Low]: '#008000', // Green
    [TaskPriority.Medium]: '#6495ED', // Cornflower Blue
    [TaskPriority.Normal]: '#00A2E8', // Blue
    [TaskPriority.High]: '#FFA500', // Orange
    [TaskPriority.Critical]: '#ED2931' // Crimson Red
};

export const TaskPriorityTextColors: { [key: number]: string } = {
    [TaskPriority.Low]: '#ffffff',
    [TaskPriority.Medium]: '#ffffff',
    [TaskPriority.Normal]: '#ffffff',
    [TaskPriority.High]: '#7A3D00',
    [TaskPriority.Critical]: '#ffffff'
};


// export const lightenColor = (hex: string, amount: number): string => {
//     const num = parseInt(hex.replace("#", ""), 16);
//     const r = Math.min(255, (num >> 16) + amount);
//     const g = Math.min(255, ((num >> 8) & 0x00FF) + amount);
//     const b = Math.min(255, (num & 0x0000FF) + amount);
//     return `rgb(${r}, ${g}, ${b})`;
// };



export const getTaskPriorityString = (taskPriorityID: number): string => {
    if (taskPriorityID === TaskPriority.Low)
        return TaskPriority[TaskPriority.Low];
    else if (taskPriorityID === TaskPriority.Medium)
        return TaskPriority[TaskPriority.Medium];
    else if (taskPriorityID === TaskPriority.Normal)
        return TaskPriority[TaskPriority.Normal];
    else if (taskPriorityID === TaskPriority.High)
        return TaskPriority[TaskPriority.High];
    else if (taskPriorityID === TaskPriority.Critical)
        return TaskPriority[TaskPriority.Critical];
}